import { HttpErrorResponse } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Store } from "@ngxs/store";
import * as ApplicationStateActions from "@vp/data-access/application";
import { ApplicationErrorEvent } from "@vp/models";
import { AppInsightsEvent } from "@vp/shared/app-insights-proxy-service";

export const ON_INIT = "ngOnInit";
export const ON_DESTROY = "ngOnDestroy";

@Injectable({
  providedIn: "root"
})
export class LoggerService {
  private readonly store = inject(Store);

  systemEvent(
    source: string,
    message: string,
    properties?: Record<string, unknown> | null | undefined
  ) {
    const systemEvent = new AppInsightsEvent({
      error: null,
      type: "event",
      source: source,
      message: message,
      properties: properties
    });

    this.store.dispatch(new ApplicationStateActions.EmitEvent(systemEvent, source));
  }

  errorEvent(
    error: unknown,
    source?: string,
    message?: string,
    properties?: Record<string, unknown>
  ) {
    let appError: ApplicationErrorEvent | AppInsightsEvent;
    if (error instanceof HttpErrorResponse) {
      appError = ApplicationErrorEvent.fromHttpErrorResponse(error, source, message, properties);
    } else if (error instanceof AppInsightsEvent) {
      appError = AppInsightsEvent.fromAnyErrorResponse(error, message, properties);
    } else {
      appError = ApplicationErrorEvent.fromAnyErrorResponse(error, message, properties);
    }
    const errorRecord = error as Record<string, unknown>;
    const _source =
      source ??
      (errorRecord?.["source"] as string) ??
      (errorRecord?.["name"] as string) ??
      "unknown";

    this.store.dispatch(new ApplicationStateActions.EmitEvent(appError, _source));
  }
}
